export default "__VITE_ASSET__Ca3gb9TF__"